import { Canvas, useFrame } from '@react-three/fiber'
import { useGLTF, MeshReflectorMaterial, BakeShadows } from '@react-three/drei'
import { EffectComposer, Bloom, DepthOfField, ToneMapping } from '@react-three/postprocessing'
import { easing } from 'maath'
import { suspend } from 'suspend-react'
import { Instances, Computers } from './Computers'
import { SpinningBox } from './SpinningBox'

const suzi = import('@pmndrs/assets/models/bunny.glb')

export default function App() {
  return (
    <>
      <Canvas shadows dpr={[1, 1.5]} camera={{ position: [-1.5, 1, 5.5], fov: 45, near: 1, far: 20 }} eventSource={document.getElementById('root')} eventPrefix="client">
        {/* Lights */}
        <color attach="background" args={['black']} />
        <hemisphereLight intensity={0.15} groundColor="black" />
        <spotLight decay={0} position={[10, 20, 10]} angle={0.12} penumbra={1} intensity={1} castShadow shadow-mapSize={1024} />
        {/* Main scene */}
        <group position={[-0, -1, 0]}>
          {/* Auto-instanced sketchfab model */}
          <Instances>
            <Computers scale={0.5} />
          </Instances>
          {/* Plane reflections + distance blur */}
          <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]}>
            <planeGeometry args={[50, 50]} />
            <MeshReflectorMaterial
              blur={[300, 30]}
              resolution={2048}
              mixBlur={1}
              mixStrength={180}
              roughness={1}
              depthScale={1.2}
              minDepthThreshold={0.4}
              maxDepthThreshold={1.4}
              color="#202020"
              metalness={0.8}
            />
          </mesh>
          {/* Bunny and a light give it more realism */}
          <Bun scale={0.4} position={[0, 0.3, 0.5]} rotation={[0, -Math.PI * 0.85, 0]} />
          <pointLight distance={1.5} intensity={1} position={[-0.15, 0.7, 0]} color="orange" />
          
          {/* Owner Photo on Spinning Box */}
          <SpinningBox position={[-2, 1.5, 0]} scale={0.5} />
        </group>
        {/* Postprocessing */}
        <EffectComposer disableNormalPass>
          <Bloom luminanceThreshold={0} mipmapBlur luminanceSmoothing={0.0} intensity={5} />
          <DepthOfField target={[0, 0, 13]} focalLength={0.3} bokehScale={15} height={700} />
        </EffectComposer>
        {/* Camera movements */}
        <CameraRig />
        {/* Small helper that freezes the shadows for better performance */}
        <BakeShadows />
      </Canvas>
      
      {/* Company logo and social links */}
      <div className="company-info">
        <div className="company-logo">
          <img src="/images/company-logo.png" alt="Company Logo" />
        </div>
        <div className="social-links">
          <a href="https://www.linkedin.com/company/justblrmatrix" target="_blank" rel="noopener noreferrer">
            <img src="/images/linkedin-icon.svg" alt="LinkedIn" />
          </a>
          <a href="https://www.instagram.com/justblrmatrix" target="_blank" rel="noopener noreferrer">
            <img src="/images/instagram-icon.svg" alt="Instagram" />
          </a>
          <a href="https://wa.me/919731038999" target="_blank" rel="noopener noreferrer">
            <img src="/images/whatsapp-icon.svg" alt="WhatsApp" />
          </a>
        </div>
      </div>
    </>
  )
}

function Bun(props) {
  const { nodes } = useGLTF(suspend(suzi).default)
  console.log(nodes)
  return (
    <mesh receiveShadow castShadow geometry={nodes.mesh.geometry} {...props}>
      <meshStandardMaterial color="#222" roughness={0.5} />
    </mesh>
  )
}

function CameraRig() {
  useFrame((state, delta) => {
    easing.damp3(state.camera.position, [-1 + (state.pointer.x * state.viewport.width) / 3, (1 + state.pointer.y) / 2, 5.5], 0.5, delta)
    state.camera.lookAt(0, 0, 0)
  })
}
